<template>
  <ul class="list c-breadcrumb">
    <li v-for="(crumb, key) in breadcrumbs" :key="key" class="c-breadcrumb__item">
      <span v-if="crumb.pathName">
        <router-link :to="{ name: crumb.pathName, query: crumb.query }">
          {{ crumb.name }}
        </router-link>
      </span>
      <span v-else>{{ crumb.name }}</span>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'Breadcrumb',
  props: {
    breadcrumbs: {
      type: Array
    }
  }
}
</script>

<style lang="scss" scoped>
.c-breadcrumb {
  list-style: none;
  text-align: left;
  margin-bottom: 8px;
  font-size: 12px;
  .c-breadcrumb__item {
    display: inline-block;
  }
  .c-breadcrumb__item::after {
    content: '/';
    display: inline-block;
    margin-left: 5px;
    margin-right: 5px;
  }
  .c-breadcrumb__item:last-child::after {
    content: none;
  }
}

</style>
